<template>
	<span v-if="availability" :class="classes" :style="paddingStyles">
		<span>
			{{ name }}
		</span>
	</span>
</template>

<script>
import { mapState } from "vuex";
import TranslationService from "../../../ceres/services/TranslationService";

export default {
    name: "item-availability",

	props: {
		paddingClasses: String,
		paddingStyles: String
	},

	inject: {
		itemId: {
			default: null
		}
	},

	computed: {
		availability() {
			const currentVariation = this.$store.getters[`${this.itemId}/currentItemVariation`];
			return currentVariation?.variation?.availability;
		},

		classes() {
			return ["availability", "availability-" + (this.availability && this.availability.id), this.paddingClasses];
		},

		name() {
			let name = this.availability?.names?.name;
			if (this.availability?.id === 1) {
				const availabilityAlternative = TranslationService.translate("Eros::Template.availabilityAlternative");

				if (availabilityAlternative !== "") {
					name =
						availabilityAlternative +
						" " +
						(this.shippingCountryId === 1
							? TranslationService.translate("Eros::Template.availAltAdditionDE")
							: TranslationService.translate("Eros::Template.availAltAdditionInt"));
				}
			} else if (this.availability?.id > 4) {
				name = "";
			}
			return name;
		},

		...mapState({
			shippingCountryId: (state) => state.localization.shippingCountryId
		})
	}
};
</script>
